export default __webpack_public_path__ + "static/media/1927.15880194.png";